import * as React from "react";
import { reconcileReconcilePost } from "../../../client/sdk.gen";
import { ReconcileReconcilePostData } from "../../../client/types.gen";
import { AccountManager } from "../../authConfig";
import type { FormulaNameStr } from "../../taskpane";
import { getUserData, getValuesFromUserTypedAddress } from "../../taskpane";
import type { ResultObject } from "../Forms/MyForm";
import MyForm from "../Forms/MyForm";
import ReviewAction from "./ReviewAction";

const accountManager = new AccountManager();
accountManager.initialize();

const runFunction = async (values: {
  [label: string]: string | FormulaNameStr;
}): Promise<ResultObject> => {
  // Auth
  const userData = await getUserData(accountManager);

  // Get values
  const cellValues = await getValuesFromUserTypedAddress(values.cellRange);
  const targetValueArray = await getValuesFromUserTypedAddress(values.targetAddress);
  const targetValue = targetValueArray ? targetValueArray[0][0] : null;

  // Set up request
  const request: ReconcileReconcilePostData = {
    body: cellValues,
    headers: {
      "bootstrap-token": userData.accessToken,
    },
    query: {
      cell_range: values.cellRange,
      target: targetValue,
      is_one_shot: false,
    },
    url: "/api/reconcile",
  };
  // Make API Call
  try {
    const response = await reconcileReconcilePost(request);
    if (response.status === 200) {
      return {
        intent: "success",
        title: "Function Executed",
        message: `The reconciler found ${response.data.length} combinations of reconciling items. Click the button below to review the results.`,
        result: response.data,
      };
    } else {
      return {
        intent: "error",
        title: "Function Failed",
        message: `The API call was unsuccessful with status code ${response.status}. ${response.error?.detail || "Unknown error"}. Please try again.`,
      };
    }
  } catch (error) {
    return {
      intent: "error",
      title: "Function Failed",
      message: `An error occurred while making the API call. Please try again. Error details: ${error}`,
    };
  }
};

const ReconcilerForm: React.FC = () => {
  // const [page, setPage] = React.useState<JSX.Element>(
  //   <MyForm/>
  //   />
  // );

  return (
    <>
      <MyForm
        title="Reconciler"
        description="Reconcile numbers in a cell range to a target value. Review the results to identify reconciling items."
        onSubmit={runFunction}
        inputs={[
          {
            labelDescription: "Cell range of numbers to reconcile",
            label: "cellRange",
            isRequired: true,
            validatorFunction: (value: string) => {
              if (value.length < 5) {
                return {
                  state: "error",
                  message: "Must be at least 5 characters",
                };
              }
              return {
                state: "success",
                message: "Looks good!",
              };
            },
            isButtonHelper: true,
            buttonHelperType: "rangePicker",
          },
          {
            labelDescription: "Cell location of target value to reconcile to",
            label: "targetAddress",
            isRequired: true,
            validatorFunction: (value: string) => {
              if (value.length < 2) {
                return {
                  state: "error",
                  message: "Must be at least 2 characters",
                };
              }
              return {
                state: "success",
                message: "Looks good!",
              };
            },
            isButtonHelper: true,
            buttonHelperType: "rangePicker",
          },
        ]}
        actionElement={ReviewAction}
        startIntentTitle="Info"
        startIntentMessage="After filling in the form data, click the Submit button."
      />
    </>
  );
};
export default ReconcilerForm;
